import VueLib from 'vue'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  const opts = Object.assign({}, {"dsn":"https:\u002F\u002Fecd88dfc68af442fbaf426c4a0c82435@sentry.io\u002F1883516","environment":"production","release":"0c2799bd1f65a924877737aa85464cf068d39253","extra":{"url":"https:\u002F\u002Fwww.kivaconfections.com","deploy_url":"https:\u002F\u002F68049bb46daa1900087f18d2--kiva.netlify.app"}}, {
    integrations: [
      new Dedupe({}),
      new ExtraErrorData({}),
      new ReportingObserver({}),
      new RewriteFrames({}),
      new Vue({Vue: VueLib, ...{"attachProps":true}})
    ]
  })

  // Initialize sentry
  Sentry.init(opts)

  // Inject Sentry to the context as $sentry
  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
